<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs headline="Học viên" :link="[{ text: 'Học viên', href: '../students' }]" />
      </div>

      <div class="d-flex">
        <v-btn
          color="primary"
          @click="onClickUpsertAbortion()"
          v-if="['super_admin', 'education_manager'].includes(role.type)"
          ><v-icon left>add</v-icon>{{ addButtonText }}</v-btn
        >
        <student-list-actions
          v-if="['super_admin', 'education_manager'].includes(role.type)"
          :selected="selected"
          @removed="selected = []"
          :filter="draw"
          @filter="draw = !draw"
        />
      </div>
    </div>

    <v-card class="pa-2 pa-md-2 mx-md-2">
      <v-row no-gutters>
        <v-col class="text-right pa-0">
          <span v-if="$vuetify.breakpoint.smAndDown">
            fora
          </span>
          <!-- <setting-table-header :default-headers="originHeaders" @change="headers = $event" /> -->
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" icon class="ml-2">
                <v-icon>mdi-settings</v-icon>
              </v-btn>
            </template>
            <v-list class="px-2" dense style="width: 200px">
              <v-list-item
                v-show="header.configurable"
                dense
                v-for="header in headers"
                :key="header.value"
              >
                <v-checkbox
                  class="mt-0"
                  hide-details="auto"
                  small
                  :label="header.text"
                  :input-value="header.show"
                  @change="onToggleHeader(header.value, !header.show)"
                ></v-checkbox
              ></v-list-item> </v-list
          ></v-menu>
          <span v-if="$vuetify.breakpoint.mdAndUp">
            <drop-menu>
              <export-excel :custom-header="headers" api="/students/" />
            </drop-menu>
          </span>
        </v-col>
      </v-row>
      <student-filter
        ref="studentFilter"
        v-if="$vuetify.breakpoint.mdAndUp"
        @onFilterChanged="refresh"
        forAbortion
      />
      <v-data-table
        :dense="true"
        item-key="id"
        disableSort
        :headers="visibleHeaders"
        :items="tableData"
        hide-default-footer
        :disable-pagination="true"
      >
        <template v-slot:no-data="">Chưa có lần thôi học nào </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn icon small @click.stop="onClickUpsertAbortion(item)">
              <v-icon v-if="canEdit" small> mdi-pencil</v-icon>
              <v-icon v-else small> mdi-eye</v-icon>
            </v-btn>
            <v-btn v-if="canEdit" icon small @click.stop="onClickDeleteAbortion(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.reason_type="{ value }">
          {{ getReasonTypeLabel(value) }}
        </template>
        <template v-slot:item.reason="{ value }">
          <span v-if="value">{{ value }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.student.name="{ item }">
          <card-student-name :student="item.student" link />
        </template>

        <template v-slot:item.tuition_status="{ value }">
          {{ getTuitionStatusLabel(value) }}
        </template>
        <template v-slot:item.abortion_date="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.student.dob="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.forced_abortion="{ value }">
          <v-icon v-if="value" color="red" small>mdi-check</v-icon>
          <span v-else>-</span>
        </template>
        <template v-slot:item.tuition_refunded="{ value }">
          <v-icon v-if="value" color="green" small>mdi-check</v-icon>
          <span v-else>-</span>
        </template>
        <template v-slot:item.document="{ value }">
          <span v-if="value">{{ value }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.student.majors`]="{ value }">
          <span v-for="(major, index) in value" :key="major.id">
            {{ major.title }}
            <span v-if="index < value.length - 1">{{ ', ' }}</span>
          </span>
        </template>
        <template v-slot:[`item.student.generation`]="{ value }">
          <span style="white-space: nowrap">{{ value ? value.code : '' }}</span>
        </template>
        <template v-slot:[`item.student.gender`]="{ value }">
          <span style="white-space: nowrap">{{ getGenderLabel(value) }}</span>
        </template>
        <template v-slot:top=""> </template>
      </v-data-table>
      <UpsertAbortionDialog
        v-if="upsertAbortionDialog.isOpen"
        :isOpen="upsertAbortionDialog.isOpen"
        :isEdit="upsertAbortionDialog.isEdit"
        :currentItem="upsertAbortionDialog.currentItem"
        @close="upsertAbortionDialog.onCancel"
        @cancel="upsertAbortionDialog.onCancel"
        @confirm="upsertAbortionDialog.callback"
      />
    </v-card>
  </div>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DateSelector from '@/components/basic/DateSelector.vue'
import ExportExcel from '@/components/basic/ExportExcel'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import UpsertAbortionDialog from '@/components/UpsertAbortionDialog.vue'
import {
  getGenderLabel,
  getPaymentMethodOptions,
  getReasonTypeLabel,
  getAbortionStatusLabel,
  getTuitionStatusLabel,
  reasonTypeOptions,
  transformDateForDatePicker,
  tuitionStatusOptions
} from '@/helpers'
import DropMenu from '@/modules/student/menu/Menu.vue'
import SingleStudentListActions from '@/modules/student/SingleStudentListActions'
import StudentFilter from '@/modules/student/StudentFilter'
import StudentFilterDialog from '@/modules/student/StudentFilterDialog'
import StudentListActions from '@/modules/student/StudentListActions'
import StudentNewDialog from '@/modules/student/StudentNewDialog'
import { cloneDeep, get, set, unset } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'


export default {
  components: {
    UpsertAbortionDialog,
    DateSelector,
    AutocompleteStudent,
    BaseDialog,
    CardStudentName,
    DropMenu,
    SingleStudentListActions,
    StudentListActions,
    StudentNewDialog,
    StudentFilter,
    Breadcrumbs,
    SettingTableHeader,
    StudentFilterDialog,
    ExportExcel
  },
  props: {
    role: String
  },
  data() {
    return {
      upsertAbortionDialog: {
        currentItem: null,
        isEdit: false,
        isOpen: false,
        callback: () => {},
        onCancel: () => {
          this.upsertAbortionDialog.isOpen = false
          this.upsertAbortionDialog.isEdit = false
          this.upsertAbortionDialog.currentItem = null
        }
      },
      headers: [
        {
          text: 'STT',
          value: 'index',
          align: 'left',
          sortable: false,
          show: true,
          configurable: false,
          width: 56
        },
        {
          text: 'Tên',
          value: 'student.name',
          align: 'left',
          sortable: false,
          show: true,
          configurable: false,
          width: 200
        },
        {
          text: 'Lớp',
          value: 'student.tags',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Chuyên ngành',
          value: 'student.majors',
          align: 'left',
          sortable: false,
          configurable: true,
          show: true,
          width: 400
        },
        {
          text: 'Khóa',
          value: 'student.generation',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Ngày sinh',
          value: 'student.dob',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Giới tính',
          value: 'student.gender',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },

        {
          text: 'Ngày thôi học',
          value: 'abortion_date',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        { text: 'Lý do', value: 'reason_type', show: true, configurable: true },
        { text: 'Chi tiết lý do', value: 'reason', show: true, configurable: true },
        { text: 'Tình trạng học phí', value: 'tuition_status', show: true, configurable: true },

        {
          text: 'SĐT',
          value: 'student.phone',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Email',
          value: 'student.email',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Bắt buộc thôi học',
          value: 'forced_abortion',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Hoàn học phí',
          value: 'tuition_refunded',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Tài liệu',
          value: 'document',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Ghi chú',
          value: 'note',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Hành động',
          value: 'actions',
          align: 'left',
          sortable: false,
          configurable: false,
          show: true
        }
      ],
      selected: [],
      draw: false,
      search: '',
      loading: false,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      studentTableOptions: {},
      onCreate: false,
      selectedStudent: {}
    }
  },
  async created() {
    this.loadDataOnCreated()
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role']),
    ...mapState('abortion', ['abortions']),
    reasonTypeOptions,
    tuitionStatusOptions,
    getPaymentMethodOptions,
    visibleHeaders() {
      return this.headers.filter(i => i.show)
    },

    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },

    typeQueryParam() {
      return get(this.$route.query, 'type', 'long_term')
    },
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm thôi học'
      }
    },
    tableData() {
      let output = this.abortions.map(({ student, ...o }, index) => ({
        student,
        ...o,
        index: index + 1
      }))

      return output
    }
  },
  methods: {
    ...mapActions('student', ['fetchStudent']),

    ...mapActions('abortion', [
      'fetchAbortions',
      'createAbortion',
      'updateAbortion',
      'removeAbortion'
    ]),
    getGenderLabel,
    transformDateForDatePicker,
    getReasonTypeLabel,

    getTuitionStatusLabel,

    formatDateField(v) {
      if (!v) {
        return v
      }
      return moment(v).format('DD/MM/YYYY')
    },
    onToggleHeader(key, value) {
      this.headers = this.headers.map(i => {
        if (i.value === key) {
          return { ...i, show: value }
        }
        return i
      })
    },
    async refresh(query) {
      unset(query, ['type'])
      unset(query, ['status'])
      this.loading = true
      const {
        _sort,
        abortion_date_gte,
        abortion_date_lte,
        reason_type,
        ...o
      } = query

      const trueQuery = { _sort, abortion_date_gte, abortion_date_lte, reason_type }
      Object.entries(o).map(([k, v]) => {
        trueQuery[`student[${k}]`] = v
      })
      await this.fetchAbortions(trueQuery)
      this.loading = false
    },
    async loadDataOnCreated() {
      // const initialType = get(this.$route.query, 'type', 'long_term')

      await this.fetchAbortions({
        // 'student[type]': initialType
      })
    },
    onClickUpsertAbortion(item) {
      let data = {
        student: '',
        abortion_date: moment().startOf('day').toISOString(),
        reason: '',
        reason_type: '',
        forced_abortion: false,
        tuition_status: null,
        tuition_refunded: false,
        document: '',
        note: ''
      }
      if (item) {
        data = cloneDeep(item)
        data.student = data.student.id
      }
      this.upsertAbortionDialog.currentItem = data
      this.upsertAbortionDialog.isEdit = !!item
      this.upsertAbortionDialog.isOpen = true
      this.upsertAbortionDialog.callback = (async payload => {
        try {
          if (item) {
            await this.updateAbortion({
              id: item.id,
              params: payload
            })
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createAbortion({
              params: payload
            })
            this.$alert.success('Tạo thành công')
          }
          await this.fetchStudent(
            this.upsertAbortionDialog.currentItem.student.id ||
              this.upsertAbortionDialog.currentItem.student
          )
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertAbortionDialog.isOpen = false
          this.upsertAbortionDialog.currentItem = null
        }
      }).bind(this)
    },
    onClickDeleteAbortion(item) {
      this.$dialog.confirm({
        title: 'Xóa thôi học',
        text: ` Bạn có Chắc Chắn xóa thông tin thôi học này?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeAbortion({ id: item.id })
          this.$alert.success('Xóa thành công')
          await this.fetchStudent(item.student.id)
        }
      })
    }
  },

  watch: {
    typeQueryParam() {
      this.$refs.studentFilter.reset()
      this.loadDataOnCreated()
    }
  }
}
</script>
<style lang="scss" scoped>
// @import '~vuetify/src/styles/styles.sass';

::v-deep {
  th,
  td {
    background-color: #fff;
  }
  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  th:nth-child(2),
  td:nth-child(2) {
    position: sticky;
    left: 56px;
    z-index: 1;
  }
}
</style>
